import { SearchResult } from '@/models/Repository'
import SystemOwnerApi from '@/api/SystemOwner'

export class SystemOwnerModel {
  constructor({ id, name, ownerProfileId, theme }) {
    this.id = Number(id) || undefined
    this.name = name || undefined
    this.ownerProfileId = ownerProfileId || undefined
    this.theme = theme || undefined
  }
  static async getList(pageNo, pageSize) {
    const result = await SystemOwnerApi.getList(pageNo, pageSize)
    const items = assignModel(result.items)
    return new SearchResult({
      count: result.count,
      pageNo: result.pageNo,
      pageSize: pageSize,
      items,
    })
  }
}

const assignModel = data => {
  return data.map(o => new SystemOwnerModel(o))
}
